/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_PhotoInputs */



/**
* | output |
* | --- |
* | "Profile photo" |
*
* @param {Settings_PhotoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo = /** @type {((inputs?: Settings_PhotoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_PhotoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Profielfoto")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Photo de profil")
	return /** @type {LocalizedString} */ ("Profile photo")
});